import { render, staticRenderFns } from "./TopUpModal.vue?vue&type=template&id=dbb63c4e&scoped=true"
import script from "./TopUpModal.vue?vue&type=script&lang=js"
export * from "./TopUpModal.vue?vue&type=script&lang=js"
import style0 from "./TopUpModal.vue?vue&type=style&index=0&id=dbb63c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb63c4e",
  null
  
)

export default component.exports